import React, { useState } from 'react';

function Footer() {
    const [inputValue, setInputValue] = useState();
    const handleChange = function (e) {
        setInputValue(e.target.value);
    };
    return (
        <>
            <section className='subscription flex-center' id='services'>
                <h2 data-aos='flip-down'>
                    Get offers stright <br />
                    to your inbox
                </h2>
                <p data-aos='fade-up'>Sign up for the Sushiman newsletter</p>

                <div className='subscription__form' data-aos='fade-up'>
                    <input
                        type='text'
                        placeholder='Enter your email address'
                        onChange={handleChange}
                        value={inputValue}
                    />
                    <button onClick={() => setInputValue('')}>
                        Get Started
                    </button>
                </div>
            </section>

            <footer className='footer flex-between'>
                <h3 className='footer__logo'>
                    <span>Sushi</span>man
                </h3>

                <ul className='footer__nav'>
                    <li>
                        <a href='#menu'>Menu</a>
                    </li>
                    <li>
                        <a href='#food'>Food</a>
                    </li>
                    <li>
                        <a href='#services'>Services</a>
                    </li>
                    <li>
                        <a href='#about-us'>About Us</a>
                    </li>
                </ul>

                <ul className='footer__social'>
                    <li className='flex-center'>
                        <img
                            src={
                                process.env.PUBLIC_URL + '/assets/facebook.svg'
                            }
                            alt='facebook'
                        />
                    </li>
                    <li className='flex-center'>
                        <img
                            src={
                                process.env.PUBLIC_URL + '/assets/instagram.svg'
                            }
                            alt='instagram'
                        />
                    </li>
                    <li className='flex-center'>
                        <img
                            src={process.env.PUBLIC_URL + '/assets/twitter.svg'}
                            alt='twitter'
                        />
                    </li>
                </ul>
            </footer>
        </>
    );
}

export default Footer;
